import "./globals.css";
import "./styles/app.css";
import { AppOrchestrator } from "./agents/AppOrchestrator";

// Set page title based on domain
const hostname = window.location.hostname.toLowerCase();
const isSingularDomain =
	hostname === "randomfart.com" || hostname === "www.randomfart.com";
document.title = isSingularDomain ? "Random Fart" : "Random Farts";

// Initialize application
const app = new AppOrchestrator();
app.initialize();

// Expose for debugging in development
if (import.meta.env.DEV) {
	(window as any).app = app;
}
